import React from 'react'
import { Document, Page, pdfjs } from 'react-pdf'

import useSubmittedProposals, {
  getDescriptionPdfUrl
} from '../hooks/useSubmittedProposals'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

const StreamDescriptionFromPdf = ({ proposal, proposalId, fileUrl }) => {
  const [numPages, setNumPages] = React.useState(null)
  const { descriptionPdfUrls } = useSubmittedProposals()
  const descriptionPdfUrl =
    fileUrl || getDescriptionPdfUrl(descriptionPdfUrls, proposal, proposalId)

  React.useEffect(() => {
    setNumPages(null)
  }, [descriptionPdfUrl])

  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages)
  }

  if (!descriptionPdfUrl) {
    return (
      <div>
        <p>No PDF available for this proposal.</p>
      </div>
    )
  }

  return (
    <div>
      <Document
        key={descriptionPdfUrl}
        file={descriptionPdfUrl}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        {numPages
          ? Array.from({ length: numPages }, (_, index) => (
              <div key={`page_${index + 1}`}>
                <Page pageNumber={index + 1} className="pdf-page" />
                <p style={{ textAlign: 'center' }}>
                  Pages: {index + 1} / {numPages}
                </p>
              </div>
            ))
          : null}
      </Document>
    </div>
  )
}

export default StreamDescriptionFromPdf
